import request from '@/utils/request'
import qs from 'qs'

/**
 * 用户授权列表
 * @param query
 */
export function fetchUserAuth(query) {
	return request({
		url: '/api/auth/user/list',
		method: 'post',
		data: query
	})
}

/**
 * 获取用户的角色
 * @param userId
 */
export function fetchRoleByUserId(userId) {
	return request({
		url: '/api/auth/user/role/' + userId,
		method: 'get'
	})
}

/**
 * 保存用户授权的角色
 * @param userId
 * @param roleIds
 */
export function saveUserAuth(userId, roleIds) {
	return request({
		url: '/api/auth/user/role/' + userId,
		method: 'put',
		data: qs.stringify({ roleIds: roleIds }, { indices: false })
	})
}

/**
 * 保存多个用户授权的角色
 * @param userId
 * @param roleIds
 */
export function batchSaveUserAuth(userIds, roleIds) {
	return request({
		url: '/api/auth/user/role',
		method: 'put',
		data: qs.stringify({ userIds: userIds, roleIds: roleIds }, { indices: false })
	})
}

/**
 * 删除授权
 * @param userId
 * @param roleIds
 */
export function remove(authId) {
	return request({
		url: '/api/auth/delete/' + authId,
		method: 'post'
	})
}

/**
 * 获取机构的授权列表
 * @param query
 */
export function fetchUnitAuth(query) {
	return request({
		url: '/api/auth/unit/list',
		method: 'post',
		data: query
	})
}

/**
 * 保存多个机构授权的角色
 * @param unitIds
 * @param roleIds
 */
export function batchSaveUnitAuth(unitIds, roleIds) {
	return request({
		url: '/api/auth/unit/role',
		method: 'put',
		data: qs.stringify({ unitIds: unitIds, roleIds: roleIds }, { indices: false })
	})
}

/**
 * 获取职务的授权列表
 * @param query
 */
export function fetchJobAuth(query) {
	return request({
		url: '/api/auth/job/list',
		method: 'post',
		data: query
	})
}

/**
 * 保存多个职务授权的角色
 * @param unitIds
 * @param roleIds
 */
export function batchSaveJobAuth(jobIds, roleIds) {
	return request({
		url: '/api/auth/job/role',
		method: 'put',
		data: qs.stringify({ jobIds: jobIds, roleIds: roleIds }, { indices: false })
	})
}

/**
 * 获取分组的授权列表
 * @param query
 */
export function fetchGroupAuth(query) {
	return request({
		url: '/api/auth/group/list',
		method: 'post',
		data: query
	})
}

/**
 * 保存多个分组授权的角色
 * @param unitIds
 * @param roleIds
 */
export function batchSaveGroupAuth(groupIds, roleIds) {
	return request({
		url: '/api/auth/group/role',
		method: 'put',
		data: qs.stringify({ groupIds: groupIds, roleIds: roleIds }, { indices: false })
	})
}
